import React from "react"
import { classNames } from "../../utils/helpers"
import Box, { BoxProps } from "../Box"

export interface ContainerProps extends BoxProps {
  constrainedToBreakPoint?: boolean
  fullWidthOnMobile?: boolean
  fullWidth?: boolean
  className?: string
}

const Container = ({
  constrainedToBreakPoint = false,
  fullWidthOnMobile = true,
  fullWidth = false,
  className,
  children,
}: ContainerProps) => {
  const classes = fullWidth
    ? ""
    : classNames(
        !fullWidthOnMobile && "max-w-full px-4",
        constrainedToBreakPoint
          ? "lg:max-w-5xl xl:max-w-7xl mx-auto"
          : "max-w-screen",
        // "mx-auto",
        className
      )
  return <Box className={classes}>{children}</Box>
}

export default Container
